export default __webpack_public_path__ + "media/2.5c5d0.png";